import React from "react";
import {Form} from "formik";

const StepLayout = ( {children, actions}) => {
    return (
        <Form noValidate>
            <div className="fieldsContainer">
                {children}
            </div>
            {actions}
        </Form>
    )
}
export default StepLayout